// Adding support for multiple messages to be deleted in one GO!
define('paychex.app.messages/data/RemoteDeleteMessages',[
    'com/paychex/widget/messageBoard/dto/DeleteMessagesRequest',
    'com/paychex/widget/messageBoard/dto/SingleMessageRequest',
    'lodash'
], function(DeleteMessagesRequest, SingleMessageRequest, _) {

    'use strict';

    return {
        callType: 'remote',
        operation: 'deleteMessages',
        destination: 'messageBoardRemote',
        baseUrl: '/landing_remote/do/json/',
        objectMapperOpts: {skipDecode: true},
        generateOperationParams: function(params, data) {
            var deleteRequest = new DeleteMessagesRequest();
            deleteRequest.multiMessageRequest = _.map(data, function getSingleMessageRequest(message) {
                var request = new SingleMessageRequest();
                request.platformMessageId = message.platformMessageId;
                request.strMessagePlatform = message.messagePlatform;
                request.strUserGuid = null;
                request.messageId = message.messageId;
                return request;
            });
            return deleteRequest;
        }
    };

});

